import { fromJS } from 'immutable';
import * as constants from './constants';

const COHORT_PATH = 'cohort';
const COHORT_LIST_PATH = 'cohorts';

const initialState = fromJS({
  cohorts: undefined,
  cohort: {},
  cohortAccounts: undefined,
});

const setCohortList = (state, cohorts) => (
  state.set(COHORT_LIST_PATH, fromJS(cohorts)));

const setSearchQuery = (state, searchQuery) => (
  state.set(constants.COHORTS_SEARCH_PATH, searchQuery));

const setSortDetails = (state, sortDetails) => (
  state.set(constants.COHORTS_SORT_PATH, sortDetails));

const addCohortToList = (state, cohort) => (
  state.update(COHORT_LIST_PATH, (list) => list.push(fromJS(cohort))));

const findCohortInList = (state, cohortId) => (
  [COHORT_LIST_PATH, state.get(COHORT_LIST_PATH).findIndex((cohort) => cohort.cohortId === cohortId)]);

const updateCohortPropInList = (state, cohortId, prop, value) => (
  state.setIn([...findCohortInList(state, cohortId), prop], value));

const setCohort = (state, cohort) => (
  state.setIn([COHORT_PATH, cohort.summary.cohortId], fromJS(cohort)));

const setCohortCollaborators = (state, cohortId, collaborators) => (
  state.setIn([COHORT_PATH, cohortId, 'collaborators'], fromJS(collaborators)));

const setCohortEnrollments = (state, cohortId, enrollments) => (
  state.setIn([COHORT_PATH, cohortId, 'enrollments'], fromJS(enrollments)));

const addCohortEnrollment = (state, cohortId, enrollment) => (
  state.updateIn([COHORT_PATH, cohortId, 'enrollments'],
    (enrollments) => enrollments.push(fromJS(enrollment))));

const setCohortDeployments = (state, cohortId, deployments) => (
  state.setIn([COHORT_PATH, cohortId, 'deployments'], fromJS(deployments)));

function reducer(state = initialState, action) {
  switch (action.type) {
    // cohort list functions
    case constants.SET_COHORT_LIST:
      return setCohortList(state, action.cohorts);
    case constants.SET_COHORT_SEARCH_QUERY:
      return setSearchQuery(state, action.searchQuery);
    case constants.SET_COHORT_SORT_DETAILS:
      return setSortDetails(state, action.sortDetails);
    case constants.ADD_COHORT_LIST_ITEM:
      return addCohortToList(state, action.cohort);
    case constants.ARCHIVE_COHORT:
      return updateCohortPropInList(state, action.cohortId, 'finishedDate', action.finishedDate);

    // cohort functions
    case constants.SET_COHORT:
      return setCohort(state, action.cohort);

    // TODO: these nested collections would be better flattened
    case constants.SET_COHORT_COLLABORATORS:
      return setCohortCollaborators(state, action.cohortId, action.collaborators);
    case constants.SET_COHORT_ENROLLMENTS:
      return setCohortEnrollments(state, action.cohortId, action.enrollments);
    case constants.ADD_COHORT_ENROLLMENT:
      return addCohortEnrollment(state, action.cohortId, action.enrollment);
    case constants.SET_DEPLOYMENTS_LIST:
      return setCohortDeployments(state, action.cohortId, action.deployments);

    default:
      return state;
  }
}

export default reducer;
